<template>

  <header id="luxbar" class="luxbar-fixed">
      <input type="checkbox" class="luxbar-checkbox" id="luxbar-checkbox"/>
      <div class="luxbar-menu luxbar-menu-right luxbar-menu-dark container">
          <ul class="luxbar-navigation">
              <li class="luxbar-header">
                  <a href="/" class="luxbar-brand">
                    <img class='hackdagio-main-logo' src="static/img/logos/hackdagio.svg" alt="HACKDAGIO">
                  </a>

                  <label class="luxbar-hamburger luxbar-hamburger-doublespin"
                  id="luxbar-hamburger" for="luxbar-checkbox"> <span></span> </label>
              </li>
                 <li class="luxbar-item"><a href="https://hackdagio.blog" target="_blank">blog</a></li>

<!--                 <li class="luxbar-item"><a href="mailto:hola@hackdagio.xyz">hola@hackdagio.xyz</a></li> -->
          </ul>
      </div>
  </header>

</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash 2s ease-in-out forwards;
}

@keyframes dash {
  to {
    stroke-dashoffset: 0;
  }
}

_::-webkit-full-page-media, _:future, :root header {
  -webkit-backdrop-filter: blur(20px);
  backdrop-filter: blur(20px);
}

_::-webkit-full-page-media, _:future, :root header .luxbar-menu-light {
  background-color: rgba(255, 255, 255, 0.6);
}

.luxbar-brand .hackdagio-main-logo {
  display: block;
  width: 200px;
  height: auto;
}
@media all and (max-width: 768px) {
  .luxbar-brand .hackdagio-main-logo {
    width: 150px;
  }
}

.luxbar-fixed {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  padding: 20px 40px;
  background: rgba(23, 24, 29, 0.95);
 }

.luxbar-fixed-bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 1000;

}

.luxbar-hamburger span, .luxbar-hamburger span::before, .luxbar-hamburger span::after {
  display: block;
  height: 3px;
  width: 3px;
  border-radius: 50%;
  transition: 0.6s ease-in-out; }

.luxbar-checkbox:checked ~ .luxbar-menu li .luxbar-hamburger span {
  background-color: transparent; }
  .luxbar-checkbox:checked ~ .luxbar-menu li .luxbar-hamburger span::before, .luxbar-checkbox:checked ~ .luxbar-menu li .luxbar-hamburger span::after {
    margin-top: 0; }

.luxbar-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  height: 58px; }

.luxbar-menu-left .luxbar-navigation, .luxbar-menu-left .luxbar-header {
  justify-content: flex-start; }

.luxbar-menu-right .luxbar-hamburger {
  margin-left: auto; }

.luxbar-brand {
  padding: 0 24px 0 24px }

.luxbar-menu {
  min-height: 58px;
  transition: 0.6s ease;
  width: 100%;
  padding: 0; }

.luxbar-navigation {
  display: flex;
  flex-direction: column;
  list-style: none;
  padding-left: 0;
  margin: 0; }

.luxbar-menu a,
.luxbar-item a {
  text-decoration: none;
  color: inherit;
  cursor: pointer; }

.luxbar-item {
  height: 58px;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0.6;
  transition: all 250ms ease-in-out;
   }
  .luxbar-item a {
    text-transform: uppercase;
    font-weight: lighter;
    letter-spacing: 5px;
    font-size: 1em;
    padding: 0 18px;
    display: block;
    color: #925900;}

.luxbar-hamburger {
  padding: 18px 24px 18px 24px;
  position: relative;
  cursor: pointer;
  margin-bottom: 0; }
  .luxbar-hamburger span::before, .luxbar-hamburger span::after {
    content: '';
    position: absolute; }
  .luxbar-hamburger span::before {
    margin-top: -8px; }
  .luxbar-hamburger span::after {
    margin-top: 8px; }

.luxbar-checkbox {
  display: none; }
  .luxbar-checkbox:not(:checked) ~ .luxbar-menu {
    overflow: hidden;
    height: 58px; }
  .luxbar-checkbox:checked ~ .luxbar-menu {
    transition: height 0.6s ease;
    height: 100vh;
    overflow: auto; }

.dropdown {
  position: relative;
  height: auto;
  min-height: 58px; }
  .dropdown:hover > ul {
    position: relative;
    display: block;
    min-width: 100%; }
  .dropdown > a::after {
    position: absolute;
    content: '';
    right: 10px;
    top: 25px;
    border-width: 5px 5px 0;
    border-color: transparent;
    border-style: solid; }
  .dropdown > ul {
    display: block;
    overflow-x: hidden;
    list-style: none;
    padding: 0; }
    .dropdown > ul .luxbar-item {
      min-width: 100%;
      height: 29px;
      padding: 5px 10px 5px 40px; }
      .dropdown > ul .luxbar-item a {
        min-height: 29px;
        line-height: 29px;
        padding: 0; }

@media screen and (min-width: 768px) {
  .luxbar-navigation {
    flex-flow: row;
    justify-content: flex-end; }

  .luxbar-hamburger {
    display: none; }

  .luxbar-checkbox:not(:checked) ~ .luxbar-menu {
    overflow: visible; }
  .luxbar-checkbox:checked ~ .luxbar-menu {
    height: 58px; }

  .luxbar-menu .luxbar-item {
    border-top: 0; }

  .luxbar-menu-right .luxbar-header {
    margin-right: auto; }

  .dropdown {
    height: 58px; }
    .dropdown:hover > ul {
      position: absolute;
      left: 0;
      top: 58px;
      padding: 0; }
    .dropdown > ul {
      display: none; }
      .dropdown > ul .luxbar-item {
        padding: 5px 10px; }
        .dropdown > ul .luxbar-item a {
          white-space: nowrap; } }
.luxbar-checkbox:checked + .luxbar-menu .luxbar-hamburger-doublespin span::before {
  transform: rotate(225deg); }
.luxbar-checkbox:checked + .luxbar-menu .luxbar-hamburger-doublespin span::after {
  transform: rotate(-225deg); }

.luxbar-checkbox:checked + .luxbar-menu .luxbar-hamburger-spin span::before {
  transform: rotate(45deg); }
.luxbar-checkbox:checked + .luxbar-menu .luxbar-hamburger-spin span::after {
  transform: rotate(-45deg); }

/******* color variables *******/
/******* default dark *******/
.luxbar-menu-dark,
.luxbar-menu-dark .dropdown ul {

  color: #fff; }

.luxbar-item:hover {
  border-bottom: 1px solid #df861d;
/*  border-radius: 120px/5px;*/

  opacity: 1; }
  .luxbar-item:hover a {
  color: #df861d;
  }
.luxbar-menu-dark .luxbar-hamburger span,
.luxbar-menu-dark .luxbar-hamburger span::before,
.luxbar-menu-dark .luxbar-hamburger span::after {
  background-color: #f39005; }


@media all and (max-width: 768px) {
  .luxbar-fixed {
    background: #16181d;
  }

  _::-webkit-full-page-media, _:future, :root .luxbar-fixed {
    background: rgba(22, 24, 29, 0.9) !important;
  }
  .luxbar-header {
    margin-bottom: 20vh;
  }
  .luxbar-item {
    text-align: center;
    justify-content: flex-start;
  }
  .luxbar-item a {
    font-size: 1em;
  }
  .luxbar-brand .hackdagio-main-logo
  {
    height: 32px;
  }
}


</style>



// WEBPACK FOOTER //
// src/components/Header.vue